<template>
  <v-form ref="driverForm" v-model="valid">
    <v-layout style="width: 100%" row wrap>
      <v-flex xs12 pl-2>
        <v-layout pt-2 class="field-padding" row wrap>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('callsign')"
              :rules="driverRules.callsign"
              v-model="driver.callsign"
              label="Callsign"
              @input="resetError('callsign')"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('fee_percentage')"
              :rules="driverRules.fee_percentage"
              v-model="driver.fee_percentage"
              type="number"
              step="1"
              suffix="%"
              label="Commission Percentage"
              @input="resetError('fee_percentage')"
            />
          </v-flex>
          <v-flex md4 />
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('driving_license_number')"
              :rules="driverRules.driving_license_number"
              v-model="driver.driving_license_number"
              label="Driving License Number"
              @input="resetError('driving_license_number')"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('hackney_number')"
              maxlength="5"
              type="number"
              class="noStepNumber"
              :rules="driverRules.hackney_number"
              v-model="driver.hackney_number"
              label="Hackney Carriage Number"
              @input="resetError('hackney_number')"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('private_hire_number')"
              maxlength="5"
              type="number"
              class="noStepNumber"
              :rules="driverRules.private_hire_number"
              v-model="driver.private_hire_number"
              label="Private Hire Number"
              @input="resetError('private_hire_number')"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <DateInputIcon
              :error-messages="errorForField('driving_license_expiry')"
              :rules="driverRules.driving_license_expiry"
              v-model="driver.driving_license_expiry"
              label="Driving License Expiry"
              @input="resetError('driving_license_expiry')"
              :clearable="true"
            ></DateInputIcon>
          </v-flex>
          <v-flex xs6 md4 px-2>
            <DateInputIcon
              :error-messages="errorForField('hackney_expiry')"
              :rules="driverRules.hackney_expiry"
              v-model="driver.hackney_expiry"
              label="Hackney Carriage Expiry"
              @input="resetError('hackney_expiry')"
              :clearable="true"
            ></DateInputIcon>
          </v-flex>
          <v-flex xs6 md4 px-2>
            <DateInputIcon
              :error-messages="errorForField('private_hire_expiry')"
              :rules="driverRules.private_hire_expiry"
              v-model="driver.private_hire_expiry"
              label="Private Hire Expiry"
              @input="resetError('private_hire_expiry')"
              :clearable="true"
            ></DateInputIcon>
          </v-flex>
        </v-layout>
        <v-flex pt-2 class="field-padding" row wrap>
          <h4 class="grey--text text--darken-1">Files</h4>
          <v-layout row wrap>
            <v-flex xs6 md4 px-2>
              <FileInput
                label="Photo"
                icon="photo_camera"
                accept="image/*"
                :required="true"
                @fileInput="handleImageInput"
                :errorMessage="errorForField('picture')"
                :rules="driverRules.picture"
              />
            </v-flex>
            <v-flex xs6 md8 px-2>
              <v-layout column>
                <FileInput
                  label="Documents"
                  icon="insert_drive_file"
                  accept="*"
                  :required="true"
                  :multiple="true"
                  @fileInput="handleDocumentInput"
                  :errorMessage="errorForField('documents')"
                />
                <div v-for="(document, index) in documentFiles" :key="document.name">
                  <v-text-field
                    maxlength="100"
                    prepend-inner-icon="description"
                    :rules="driverRules.documentDescription"
                    :label="document.name + ' Description'"
                    v-model="documentFiles[index].description"
                  />
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <CurrentFiles
          v-if="(currentDocuments != null && currentDocuments != []) || (pictureUrl != null && pictureUrl != '')"
          :currentDocuments="currentDocuments"
          :pictureUrl="pictureUrl"
          @deletePicture="deletePicture"
          @deleteDocument="deleteDocument"
          @viewDocument="viewDocument"
        />
        <v-flex pt-2 class="field-padding" row wrap>
          <v-flex xs12>
            <h4 class="grey--text text--darken-1">Other Details</h4>
          </v-flex>
          <v-layout row wrap>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('address_line_1')"
                maxlength="100"
                :rules="driverDetailsRules.address_line_1"
                v-model="driver_details.address_line_1"
                label="Address Line 1"
                @input="resetError('address_line_1')"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('address_line_2')"
                maxlength="100"
                :rules="driverDetailsRules.address_line_2"
                v-model="driver_details.address_line_2"
                label="Address Line 2"
                @input="resetError('address_line_2')"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('town')"
                maxlength="50"
                :rules="driverDetailsRules.town"
                v-model="driver_details.town"
                label="Town"
                @input="resetError('town')"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('county')"
                maxlength="50"
                :rules="driverDetailsRules.county"
                v-model="driver_details.county"
                label="County"
                @input="resetError('county')"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('postcode')"
                maxlength="8"
                :rules="driverDetailsRules.postcode"
                v-model="driver_details.postcode"
                label="Postcode"
                @input="resetError('postcode')"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('home_phone')"
                prepend-inner-icon="phone"
                maxlength="12"
                type="number"
                class="noStepNumber"
                :rules="driverDetailsRules.home_phone"
                v-model="driver_details.home_phone"
                label="Home Phone Number"
                @input="resetError('home_phone')"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex pt-2 class="field-padding" row wrap>
          <v-layout row wrap>
            <v-flex xs6 md6 px-2>
              <v-checkbox
                required
                v-model="driver_details.adt"
                color="primary"
                label="Advanced Driver Training (ADT)"
              />
            </v-flex>
            <v-flex xs6 md6 px-2>
              <v-checkbox required v-model="driver_details.b_tech" color="primary" label="B-Tech" />
            </v-flex>
            <v-flex xs6 md6 px-2>
              <v-checkbox
                required
                v-model="driver_details.nvq"
                color="primary"
                label="National Vocational Qualification (NVQ)"
              />
            </v-flex>
            <v-flex xs6 md6 px-2>
              <v-checkbox
                required
                v-model="driver_details.wheelchair_cert"
                color="primary"
                label="Wheelchair Certificate"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import DateInputIcon from "@/components/widget/input/DateInputIcon.vue";
import FileInput from "@/components/widget/input/FileInput.vue";
import CurrentFiles from "@/components/driver/CurrentFiles.vue";

export default {
  name: "driver_form",
  components: {
    DateInputIcon,
    FileInput,
    CurrentFiles,
  },
  props: {
    driver: Object,
    driver_details: Object,
    errors: { type: Object, default: () => {} },
    currentDocuments: { type: Array, default: () => [] },
    pictureUrl: { type: String, default: "" },
  },
  data: function () {
    return {
      valid: false,
      driverRules: {
        driving_license_number: [],
        callsign: [
          (v) =>
            !v ||
            (v.length > 0 && v.length < 6) ||
            "Callsign must not exceed 6 digits",
        ],
        hackney_number: [
          (v) =>
            !v ||
            (v.length >= 1 && v.length <= 6) ||
            "Hackney carriage number must be from 3 to 6 digits",
        ],
        private_hire_number: [
          (v) =>
            !v ||
            (v.length >= 1 && v.length <= 6) ||
            "Private hire number must be from 3 to 6 digits",
        ],
        driving_license_expiry: [
          (v) =>
            !v ||
            /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(v) ||
            "Driving license expiry is in an invalid format",
        ],
        hackney_expiry: [],
        private_hire_expiry: [],
        fee_percentage: [
          (v) =>
            !v ||
            (v && parseInt(v) >= 0 && parseInt(v) <= 100) ||
            "Commission Percentage must be between 0 and 100",
        ],
        picture: [],
        documentDescription: [(v) => !!v || "Document description is required"],
      },
      driverDetailsRules: {
        address_line_1: [
          (v) =>
            (v || "").length <= 100 ||
            "First address line cannot exceed 100 characters",
        ],
        address_line_2: [
          (v) =>
            (v || "").length <= 100 ||
            "Second address line cannot exceed 100 characters",
        ],
        town: [
          (v) => (v || "").length <= 50 || "Town cannot exceed 50 characters",
        ],
        county: [
          (v) => (v || "").length <= 50 || "County cannot exceed 50 characters",
        ],
        postcode: [
          (v) => (v || "").length <= 8 || "Town cannot exceed 8 characters",
        ],
        home_phone: [
          (v) =>
            (v || "").length <= 12 ||
            "Home phone number cannot exceed 12 digits",
        ],
      },
      documentFiles: [],
    };
  },
  methods: {
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function (field) {
      try {
        if (field == "hackney_number") {
          this.errors["hackney_number"] = "";
          this.errors["hackney_expiry"] = "";
          this.errors["private_hire_number"] = "";
        }
        if (field == "private_hire_number") {
          this.errors["private_hire_number"] = "";
          this.errors["private_hire_expiry"] = "";
          this.errors["hackney_number"] = "";
        }
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    handleImageInput: function (file) {
      this.$emit("imageInput", file);

      this.driverRules.picture = [];
      this.errors.picture = "";
      this.$refs.driverForm.resetValidation();

      console.log("Image input");
      console.log(this.errors);
    },
    handleDocumentInput: function (files) {
      let newDocumentFiles = [];
      files.forEach(function (file) {
        let newFile = {
          ...file,
          description: "",
        };
        newDocumentFiles.push(newFile);
      });
      this.documentFiles = newDocumentFiles;
    },
    validateForm: function () {
      this.$refs.driverForm.validate();
    },
    deletePicture: function () {
      this.$emit("deletePicture");
    },
    deleteDocument: function (fileID) {
      this.$emit("deleteDocument", fileID);
    },
    viewDocument: function (fileID) {
      this.$emit("viewDocument", fileID);
    },
  },
  watch: {
    documentFiles: {
      handler: function () {
        this.$emit("documentInput", this.documentFiles);
      },
      deep: true,
    },
    valid: function () {
      this.$emit("validityChange", this.valid);
    },
    pictureUrl: function () {
      console.log("Picture URL");

      this.driverRules.picture = [];
      this.errors["picture"] = "";
      let rule;
      if (this.pictureUrl == null || this.pictureUrl == "") {
        rule = (v) => !!v || "Photo is required";
      } else {
        rule = (v) =>
          v == null ||
          v == "" ||
          "Please delete current driver image to use a new one";
      }
      this.driverRules.picture.push(rule);
      this.$refs.driverForm.resetValidation();
    },
  },
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>